import script from "./ProfileContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileContent.vue?vue&type=script&setup=true&lang=js"

import "./ProfileContent.vue?vue&type=style&index=0&id=b04e944c&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b04e944c"]])

export default __exports__